import { scrollToElement } from "../utilities/scrollToElement";


/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find("input, select").each(function () {
            if (!this.validity.valid) {
                $(this).trigger("invalid", this.validity);
            }
        });
        $("[data-toggle='tooltip']").tooltip("hide");
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    $(form).find(".form-control.is-invalid").removeClass("is-invalid");
}

/**
 * @function
 * @description - Reinitialize a form input value and state
 * @param {Element} element - Form input element
 */
const reinitInput = element => {
    if (!element) return;

    if (element.value !== "") {
        element.value = "";
        element.classList.remove("filled", "is-invalid");
    }
};

/**
 * @function
 * @description - Toggle input label animation
 * @param {Element} element - Input element
 */
const toggleNoLabelAnimationClass = element => {
    element.classList.add("no-transition");
    setTimeout(() => { element.classList.remove("no-transition"); }, 200);
};

/**
 * Remove validation for the specified input.
 * @param {element} element - Input element to be cleared
 * @returns {void}
 */
const clearInput = elem => $(elem).removeClass("is-invalid");

/**
 * @function
 * @description - Toggle form field missing error
 * @param {Element} $formElement - Input element
 * @param {Element} $errorContainer - Error message container
 * @param {Boolean} displayError - Display error
 * @param {Element} submitButton - Form submit button
 */
const missingValueError = ($formElement, $errorContainer, displayError, submitButton = {}) => {
    const emptyFieldError = $formElement.dataset.missingError;

    if (submitButton.length) {
        submitButton[0].disabled = displayError;
    }
    $errorContainer.innerHTML = "";

    if (displayError) { $errorContainer.textContent += emptyFieldError; }

    $errorContainer.classList.toggle("error", displayError);
    $formElement.classList.toggle("check-error", displayError);
};

module.exports = {
    invalid: function () {
        $("form input, form select").on("invalid", function (e) {
            e.preventDefault();
            this.setCustomValidity("");

            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass("is-invalid");
                const prefixSiblings = $(this).siblings(".prefix");
                if (prefixSiblings.length) {
                    prefixSiblings.addClass("is-invalid");
                }
                if (this.validity.patternMismatch && $(this).data("pattern-mismatch")) {
                    validationMessage = $(this).data("pattern-mismatch");
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data("range-error")) {
                    validationMessage = $(this).data("range-error");
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data("range-error")) {
                    validationMessage = $(this).data("range-error");
                }
                if (this.validity.valueMissing && $(this).data("missing-error")) {
                    validationMessage = $(this).data("missing-error");
                }
                $(this).parents(".form-group").find(".invalid-feedback")
                    .text(validationMessage);
            }
        });
    },

    submit: function () {
        $("form").on("submit", function (e) {
            return validateForm.call(this, e);
        });
    },

    buttonClick: function () {
        $("form button[type=\"submit\"], form input[type=\"submit\"]").on("click", function (e) {
            const currentElement = e.currentTarget;
            const currentForm = currentElement.closest("form");

            // clear all errors when trying to submit the form
            clearForm($(this).parents("form"));
            if (!currentForm.reportValidity()) {
                const firstErrorInput = currentForm.querySelectorAll(".is-invalid")[0];
                if (!firstErrorInput) { return; }
                scrollToElement($(firstErrorInput), 1500);
            }
        });
    },

    formsInputValidation: function () {
        $("form input:not(:checkbox)").on("focusout blur", function (e) {
            const $this = $(this);

            if (validateForm.call(this, e)) {
                clearInput($this);
            }

            if ($this.hasClass("filled") && $this.val() == "" && e.type === "blur") {
                $this.removeClass("filled");
                $("[data-toggle='tooltip']").tooltip("hide");
            }
        });
    },

    coverageAreaInputValidation: function () {
        $(".coverage-area-form input").focusout(function (e) {
            if (validateForm.call(this, e)) {
                clearInput($(this));
                $(".coverage-area-error").addClass("d-none");
            }
        });
    },

    formsRequiredCheckboxesValidation: () => {
        $(".pwc-form-checkbox input").on("change", e => {
            const $element = e.currentTarget;

            if ($element.checked) { clearInput($element); }
        });
    },

    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: clearForm,
        clearInput: clearInput,
        missingValueError: missingValueError,
        reinitInput: reinitInput,
        toggleNoLabelAnimationClass: toggleNoLabelAnimationClass
    }
};
